<template>
  <Dialog :visible="showDialog" modal
  :style="{ width: '30rem' }" class="mx-4">
    <template #header></template>
    <h2 class="text-center">
      {{ $t('SimilarKssWarningOverlayComponent.similarFound', { text: featureName }) }}
    </h2>
    <div class="flex-grow overflow-y-auto overscroll-contain">
      <div class="flex flex-col items-center p-5 gap-5">
        <similar-kss-item-component v-for="(item, index) in getSimilarTasks" :key="index"
                                    :item="item"/>
      </div>
      <div class="text-center text-xl mt-5">
        {{ $t('SimilarKssWarningOverlayComponent.doYouWantToCreate', { text: featureName }) }}
      </div>
      <div class="flex flex-wrap justify-around gap-3 sticky bottom-0 py-3 px-0 my-6">
        <button class="btn-secondary inline-block px-5 py-3 my-1 text-base"
                type="button"
                @click.prevent="closeOverlay">
          {{ $t('SimilarKssWarningOverlayComponent.cancel') }}
        </button>
        <button class="btn-primary-accent inline-block px-5 py-3 my-1 text-base"
                type="button"
                :disabled="submitDisabled"
                @click.prevent="createTask">
          {{ $t('SimilarKssWarningOverlayComponent.create') }}
        </button>
      </div>
    </div>
  </Dialog>
</template>

<script>
import SimilarKssItemComponent
  from '@/components/Home/Shared/FrontendOverlays/SimilarKssWarningComponents/SimilarKssItemComponent.vue';
import { Dialog } from 'primevue';
import { getFeatureDisplayNameOrFallback } from '@/utils/featureDisplay';

export default {
  name: 'SimilarKssWarningOverlayComponent',
  props: {
    data: {
      type: Object,
      required: true,
    },
    showDialog: Boolean,
  },
  components: { SimilarKssItemComponent, Dialog },
  data() {
    return {
      submitDisabled: false,
    };
  },
  computed: {
    getSimilarTasks() {
      return this.$store.state.kss.similarTasks;
    },
    featureName() {
      return getFeatureDisplayNameOrFallback(
        this.$store,
        'kssTracker',
        this.$t('FallbackTexts.collaborationTracker'),
        this.$i18n?.locale,
      );
    },
  },
  methods: {
    scrollToElement() {
      const el = this.$refs.popupel;

      if (el) {
        // Use el.scrollIntoView() to instantly scroll to the element
        el.scrollIntoView({ behavior: 'smooth' });
      }
    },
    async createTask() {
      try {
        const postData = { ...this.data };
        this.submitDisabled = true;
        postData.forceSimilarTask = true;
        await this.$store.dispatch('createKssTask', postData);
        this.$toast.add({
          severity: 'success',
          summary: this.$t('ToastComponent.kss.kssCreated', { text: this.featureName }),
          detail: '',
          life: 3000,
        });
        // this.closeOverlay();
        this.submitDisabled = false;
      } catch (error) {
        this.submitDisabled = false;
        const roleDeniedHandled = await this.$store.dispatch(
          'assessmentRoleDenied/maybeShowFromApiError',
          error,
          { root: true },
        );
        if (!roleDeniedHandled) {
          this.$toast.add({
            severity: 'error',
            summary: error.response?.data?.message,
            detail: '',
            life: 3000,
          });
        }
      } finally {
        this.$emit('update:visible', false);
        this.$emit('confirmed');
      }
    },
    closeOverlay() {
      this.$store.commit('removeFrontendOverlay', this.data.id);
    },
  },
  mounted() {
    setTimeout(() => this.scrollToElement(), 150);
  },
};
</script>
